import type { TrackingFeature } from '@shared/types/tracking.ts';
import type { BlackFridaySliderItem, TileListItem } from '@tilelist/domain/composition/TileListitem.ts';
import { isBlackFridaySliderItem } from '@tilelist/domain/composition/TileListitem.ts';

export const BLACK_FRIDAY_SLIDER_FEATURE_ID = 'find_slider_1';
const SLIDER_TYPE = 'blackfriday_slider';
const BLACK_FRIDAY_SLIDER_LIST_FEATURE = 'blackFridaySlider';

export function sliderTileFeatureId(position: number): string {
    return `find_slider_tile_${position}`;
}

export function blackFridaySliderLabels() {
    return { san_ListSliderType: [SLIDER_TYPE], 'wk.san_ListFeatures': [BLACK_FRIDAY_SLIDER_LIST_FEATURE] };
}

/**
 *
 *
 */
export function listFeaturesLabels(items: TileListItem[] = []): { 'wk.san_ListFeatures'?: string[] } {
    const slider = items.find(isBlackFridaySliderItem);
    if (slider?.state === 'pending') return {};

    return { 'wk.san_ListFeatures': [slider?.state === 'ready' ? BLACK_FRIDAY_SLIDER_LIST_FEATURE : 'none'] };
}

/*                                                                  */
export function blackFridaySliderLoadedLabels(slider: BlackFridaySliderItem) {
    return slider.state === 'ready' ? blackFridaySliderLabels() : { 'wk.san_ListFeatures': ['none'] };
}

/*                                                               */
export function blackFridaySliderFeatures(slider: BlackFridaySliderItem): TrackingFeature[] {
    if (slider.state !== 'ready') return [];

    return [
        {
            id: BLACK_FRIDAY_SLIDER_FEATURE_ID,
            name: 'BlackFridaySlider',
            status: 'loaded',
        },
        ...slider.items.map((item): TrackingFeature => ({
            id: sliderTileFeatureId(item.localListPosition),
            name: 'BlackFridaySlider-Tile',
            variationId: item.product.bestVariationId,
            status: 'loaded',
            parentId: BLACK_FRIDAY_SLIDER_FEATURE_ID,
            labels: { san_ProductType: [item.product.productType] },
        })),
    ];
}
